export default {
    state: {
        language: "en_US",
        fontSize:0,
        selectMenu:0,
        innerWidth:0,
        formatDate:function(){},
        swiperOption: {
            slidesPerView: 2.2,
            spaceBetween: 0,
        },
        coursesType:0,
        pathType:0,
        walkOption:0,
        formData:{},
        zi:'All',
        isPreview:false,
        occupationsFilter:{}
    },
    mutations: {

        setLanguage(state, language) {
            state.language = language;
        },
        formatDate:function(){}
    },
    getters: {
        getContent: (state) => (object) => {
            
        	return !object||object.length==0?"":object.find(o=>o.langCode==state.language).content;
        },
        getObject: (state) => (object) => {
            
            return !object||object.length==0?{}:object.find(o=>o.langCode==state.language);
        }
    }
}